import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../../assets/styles/dab.css'

interface IConfirmModalProps {
	isShowModal: boolean;
	modalChange: any;
	deleteMessage: string;
	modalTitle?: string;
	cancelText?: string;
}

interface IConfirmModalState {
	modal: boolean;
	backdrop: string;
	modalTitleText: string;
}

class ConfirmModal extends React.Component<IConfirmModalProps, IConfirmModalState>  {
	state: { modal: boolean; backdrop: string; modalTitleText: string; };
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			backdrop: "static",
			modalTitleText: "Delete"
		};
		this.toggle = this.toggle.bind(this);
		this.handleOnsubmit = this.handleOnsubmit.bind(this);
	}

	componentDidMount() {
		const { isShowModal } = this.props;
		this.setState({ modal: isShowModal });
	}

	toggle(isDelete) {
		this.setState(prevState => ({
			modal: !prevState.modal
		}));
		this.props.modalChange(false, !this.state.modal);
	}


	// TODO unsafe lifecycle method ("https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html")

/*	componentWillReceiveProps(newProps) {
		const oldProps = this.props
		if (oldProps.isShowModal !== newProps.isShowModal) {
			this.setState({ modal: newProps.isShowModal })
		}
	}*/

	// instead of componentWillReceiveProps lifecycle method
	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.isShowModal !== prevState.isShowModal) {
			return ({ modal: nextProps.isShowModal })
		}
		return null
	}

	handleOnsubmit(event) {
		this.toggle(true);
		this.props.modalChange(true, true);
	}

	render() {
		return (
			<div data-testid="confirmationModal">
				<Modal isOpen={this.state.modal} toggle={this.toggle} backdrop="static" >
					<ModalHeader className="modal-header" toggle={this.toggle}>{this.props.modalTitle?.trim() || this.state.modalTitleText}</ModalHeader>
					<ModalBody className="modal-body">
						{this.props.deleteMessage}
					</ModalBody>
					<ModalFooter>						
						<button type="button" className="btn btn-primary" onClick={this.handleOnsubmit}>Confirm</button>
						<button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.toggle}>{this.props.cancelText || "Close"}</button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}

export default ConfirmModal;